import { render, staticRenderFns } from "./ControlTheme.vue?vue&type=template&id=07c86c3f&"
import script from "./ControlTheme.vue?vue&type=script&lang=js&"
export * from "./ControlTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports